import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { StepPageWrapper } from '@Layout/index';
import { RegisteredAddressForm } from './registeredAddressForm/RegisteredAddressForm';
import { RegisteredAddressExplanation } from './components/RegisteredAddressExplanation';
import { useRegisteredAddressLogic } from './hooks/useRegisteredAddressLogic';

export const RegisteredAddress = () => {
  const { t } = useTranslation();
  const {
    formMethods,
    handleSubmit,
    isPending,
    defaultValues,
    customerAddressData,
    isHomeAddressUS,
    usStates,
  } = useRegisteredAddressLogic();

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        isLoading={isPending}
        heading={t('sectionTitles.businessDetails')}
        content={t('pages.registeredAddress.title')}
        headingContainerCustomStyle='mb-[5px]'>
        <RegisteredAddressExplanation />
        <div className='form-provider-base'>
          <RegisteredAddressForm
            formMethods={formMethods}
            defaultValues={defaultValues}
            customerAddressData={customerAddressData}
            isHomeAddressUS={isHomeAddressUS}
            usStates={usStates}
          />
        </div>
      </StepPageWrapper>
    </FormProvider>
  );
};
